// @flow
import React from 'react';

export type StateProps = {
  contacts: {
    adresse: string,
    adresse_map: string,
    telephone: string,
    email: string,
    horaires: string
  }
};

type Props = StateProps;

function ContactDetails({
	contacts: {
		adresse,
		adresse_map,
		telephone,
		email,
		horaires,
	}
}: Props) {
	return (
		<div className="block-contact__infos">
			<h4 className="ft-h3 mb-3">Contact de la ligue</h4>
			<div>
				<h5 className="ft-h4">Adresse</h5>
				<p className="mb-2">
					<i className="icon icon-place"></i>
					<a
						href={`https://www.google.com/maps/dir/?api=1&destination=${adresse_map}`}
						dangerouslySetInnerHTML={{__html: adresse}}
						target="_blank"
						rel="noopener noreferrer"></a>
				</p>
				<h5 className="ft-h4">Adresse email</h5>
				<p className="mb-2">
					<i className="icon icon-mail"></i>
					<a href={`mailto:${email}`}>{email}</a>
				</p>
				<h5 className="ft-h4">Téléphone</h5>
				<p>
					<i className="icon icon-phone2"></i>
					<a href={`tel:${telephone}`}>{telephone}</a>
				</p>
			</div>
			<div>
				<h5 className="ft-h4">Horaires</h5>
				<p dangerouslySetInnerHTML={{__html: horaires}}></p>
			</div>
		</div>
	);
};

export default ContactDetails;